import React from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom-v5-compat";

import { PageContent, PrimaryAction, LinkButton } from "../../Atoms";
import { useVenue } from "../../VenueContext";
import { useSession } from "../Session/SessionContext";

const OrderPlaced = () => {
  const { t } = useTranslation("onsite");
  const session = useSession();
  const venue = useVenue();
  const { orderId } = useParams();
  if (!session.customerTab) return <div>no tab</div>;
  const placedOrder = session.customerTab.orders.find(
    (order) => order.uuid === orderId,
  );
  if (!placedOrder) return <div>no order</div>;

  const primaryAction = (
    <LinkButton to="/your-order/pending" primary>
      {t("orderConfirmed.backToTab")}
    </LinkButton>
  );
  return (
    <PageContent className="space-y-32">
      <div className="mx-auto max-w-md md:space-y-64">
        <div>
          <div className="flex-1 space-y-16 text-center">
            <div className="text-lg font-semibold">
              {" "}
              {t("orderConfirmed.yourOrderNumberIs")}
            </div>
            <div className="text-center text-3xl font-bold">
              {placedOrder.orderNumber}
            </div>
            <div className="text-2xl font-semibold">
              {t("orderConfirmed.orderWillBeReadySoon", {
                venueName: venue.name,
              })}
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="flex h-full min-h-256 flex-1 flex-col justify-between">
            <div className="hidden md:block"> {primaryAction}</div>
            <PrimaryAction>{primaryAction}</PrimaryAction>
          </div>
        </div>
      </div>
    </PageContent>
  );
};
export default OrderPlaced;
